jQuery( document ).ready(function( $ ) {

'use strict';

$('.sc-search').each(function(){

	var $this = $(this),
		$input = $this.find('input[type=text]'),
		$form = $this.find('form'),
		$submit = $form.find('.sc-search__button'),
		cache = {},
		templates = {
			pending: $this.find('.sc-search__template-pending').html(),
			suggestion: $this.find('.sc-search__template-suggestion').html(),
			notFound: $this.find('.sc-search__template-not-found').html()
		},
		model = $this.data('json'),
		topSuggestion
	;

	// Shared config — passed to initTypeahead so filters can reuse or extend them.
	const typeaheadOptions = {
		minLength: 3,
		highlight: true,
		autoselect: true,
		hint: true
	};

	const displayKey = function(suggestion) {
		return stripTags(suggestion.post_title);
	};

	const bloodhound = new Bloodhound({
		datumTokenizer: Bloodhound.tokenizers.whitespace,
		queryTokenizer: Bloodhound.tokenizers.whitespace,
		remote: {
			url: model.endpoint + '?q=%QUERY',
			wildcard: '%QUERY',
			rateLimitWait: 600,
			transform: function(response){
				cacheSet(response.results);
				return response.results;
			}
		}
	});

	const dataset = {
		name: 'search',
		displayKey: displayKey,
		source: bloodhound,
		limit: 10,
		templates: {
			suggestion: function(input){ return Mustache.render(templates.suggestion, input); },
			pending: function(input){ return Mustache.render(templates.pending, input); },
			notFound: function(input){ return Mustache.render(templates.notFound, input); }
		}
	};

	// Default implementation — a registered filter can override this by providing
	// a same-named method via $this.data('filters').
	function initTypeahead({ $input, typeaheadOptions, dataset, setTopSuggestion }) {
		$input.typeahead(typeaheadOptions, dataset)
			.on('typeahead:render', function(event, suggestions) {
				setTopSuggestion(suggestions[0]);
			});
	}

	const module = Object.assign({initTypeahead}, $this.data('filters') || {});

	module.initTypeahead({
		$input,
		typeaheadOptions,
		bloodhound,
		dataset,
		templates,
		displayKey,
		setTopSuggestion: function(suggestion) {topSuggestion = suggestion;}
	});

	$form.on('submit', onSubmit);


	function onSubmit(event){

		var searchTerm = $this.find('.tt-hint').val(),
			searchResult = cacheGet(searchTerm) || topSuggestion
		;

		$submit.prop('disabled', true);

		if(searchResult){
			event.preventDefault();
			window.location = searchResult.url;
		}
	}


	/**
	 * [setCache description]
	 * @param {[type]} items [description]
	 */
	function cacheSet(items){

		cache = _.chain(items)
			.indexBy(function(item){
				return item.post_title.toLowerCase();
			})
			.extend(cache)
			.value();
	}


	/**
	 * [isCached description]
	 * @param  {[type]}  item [description]
	 * @return {Boolean}      [description]
	 */
	function cacheGet(searchTerm){

		var key = searchTerm.toLowerCase();

		if(cache[key]){
			return cache[key];
		}
	}


	/**
	 * Strip HTML tags.
	 * This could be replaced with _.stripTags if we upgrade underscore.
	 * @param string html
	 * @return string
	 */
	function stripTags(html) {
		return $('<div/>').html(html).text();
	}
});
}); // EOF ready
